import * as React from "react";
import { Navigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

// For routes that can only be accessed by admin users
function AdminGuard({ children }) {
  const { isInitialized, user } = useAuth();

  if (isInitialized && !user?.isAdmin) {
    return <Navigate to="/auth/403" />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default AdminGuard;
